import React from 'react';
import RadioListField, {
	RadioListFieldProps,
} from '../../../../Components/Form/components/RadioListField';

const YES_NO_FIELD_OPTIONS = [
	{
		title: 'base.yes',
		value: true,
	},
	{
		title: 'base.no',
		value: false,
	},
];

const YesNoRadioField: React.FC<Omit<RadioListFieldProps, 'data'>> = props => (
	<RadioListField {...props} data={YES_NO_FIELD_OPTIONS} />
);
export default YesNoRadioField;
